import VueApollo from 'vue-apollo';
import { ApolloClient, InMemoryCache, createHttpLink, from } from '@apollo/client/core';
import { setContext } from '@apollo/client/link/context';
import * as RealmWeb from 'realm-web';
import axios from 'axios';
import { clearAuth } from '@/services/secureStorage';
import { useRealmAppState } from './store';

const { app } = useRealmAppState(['app']);
// Install the vue plugin
// Name of the localStorage item
const AUTH_TOKEN = 'apollo-token';

//  Mongo App Setup

// Creates needed headers
const httpEndpoint = process.env.VUE_APP_GRAPHQL_HTTP;
const httpLink = createHttpLink({ uri: httpEndpoint });

const authorizationHeaderLink = () =>
  setContext(async (_, { headers }) => {
    if (app.value.currentUser) {
      // Refreshing custom data also refreshes the access token
      await app.value.currentUser.refreshCustomData();
    } else {
      // If no user is logged in, log in an anonymous user
      await app.value.logIn(RealmWeb.Credentials.anonymous());
    }
    // Get a valid access token for the current user
    const accessToken = app.value.currentUser?.accessToken;

    // Set the Authorization header, preserving any other headers
    return {
      headers: {
        ...headers,
        Authorization: `Bearer ${accessToken}`
      }
    };
  });

// Create the Apollo client with modern @apollo/client
const apolloClient: any = new ApolloClient({
  link: from([authorizationHeaderLink(), httpLink]),
  cache: new InMemoryCache(),
  connectToDevTools: process.env.NODE_ENV === 'development'
});

export async function onLogin(token) {
  if (typeof localStorage !== 'undefined' && token) {
    localStorage.setItem(AUTH_TOKEN, token);
    const response = await axios.get(`${process.env.VUE_APP_AUTH0}/permissions`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('apollo-token')}`
      }
    });
    if (response?.data?.data) {
      localStorage.setItem('permissions', response?.data?.data?.permissions);
      localStorage.setItem('statistics', JSON.stringify(response?.data?.data?.statistics));
    }
  }
  // try {
  //   await apolloClient.resetStore();
  // } catch (e) {
  //   // eslint-disable-next-line no-console
  //   console.log('%cError on cache reset (login)', 'color: orange;', e.message);
  // }
}

// Manually call this when user log out
export async function onLogout() {
  // Remove all auth artefacts via secureStorage abstraction (handles
  // both localStorage and cookie modes transparently)
  clearAuth();

  // Legacy clean-up: some older screens still check these keys directly.
  if (typeof localStorage !== 'undefined') {
    localStorage.removeItem(AUTH_TOKEN);
    localStorage.removeItem('apollo-refresh-token');
  }

  // Remove any default auth header we may have set on axios so that
  // subsequent unauthenticated requests don't carry a stale token.
  delete axios.defaults.headers.common.Authorization;

  // Optionally reset Apollo cache (commented out to avoid expensive refetches; uncomment if needed)
  // try {
  //   await apolloClient.resetStore();
  // } catch (e) {
  //   console.warn('Error on cache reset (logout)', e.message);
  // }
}
const provider = new VueApollo({
  defaultClient: apolloClient
});
export default provider;
// watchEffect(() => {
//   if (app.value.currentUser) {
//     onLogin(app.value.currentUser.accessToken);
//   } else {
//     onLogout();
//   }
// });
